import React from 'react'
import PageForm from 'components/pageForm/PageForm.js'
import ListBodyVivier from './components/content/body.list.vivier.js'


function ListAllVivier() {
  return (
    <>
    <PageForm>
        <div className={'col-span-12 p-3 h-full space-y-4'}>
          <ListBodyVivier/>
        </div>
    </PageForm>
</>
  )
}

export default ListAllVivier